import { NoTzDate } from "../DateUtils"
import { PrivilegeType } from "../../Enums/ChoiceEnums"

export interface IQuickPayChartResult {
    patientId: number,
    address1?: string,
    address2?: string,
    city?: string,
    state?: string,
    zip?: string,
    country?: string,
    email?: string,
    phoneHome?: string,
    phoneWork?: string,
    phoneOther?: string,
    pcp?: string,
    primaryIdType?: string,
    primaryId?: string,
    maritalStatus?: string,
    language?: string,
    employer?: string,
    ethnicity?: string,
    race?: string
}

export interface IQuickPayInsuredItem {
    payerName: string,
    payerPhone?: string,
    idCode?: string,
    groupPolicyNumber?: string,
    copay: string,
    deductable: string,
    insuranceType?: string,
    relationship?: string,
    coverage?: number,
    signatureOnFileDate?: NoTzDate,
    startDate?: NoTzDate
}

export interface IQuickPayResponsiblePartyItem {
    respPartyName: string,
    address1?: string,
    address2?: string,
    city?: string,
    state?: string,
    zip?: string,
    country?: string,
    phoneHome?: string,
    phoneWork?: string,
    phoneOther?: string
}

export interface IQuickPayContactItem {
    contactName: string,
    phoneHome?: string,
    phoneWork?: string,
    phoneOther?: string
}

export interface IQuickPayAppointmentItem {
    appointmentDate: string,
    duration: string,
    resourceName?: string,
    serviceLocationName?: string,
    appointmentStatus?: string
    appointmentType?: string
}

export interface IQuickPayCaseItem {
    careDate: NoTzDate,
    program?: string,
    status?: string,
    caseManager?: string
}

export interface IQuickPayRecallItem {
    recallReminderId: number,
    dueDate: NoTzDate,
    resourceName: string,
    appointmentType?: string,
    comments?: string,
    patientEid?: number,
    resourceId?: number,
    recallStatusCode?: QuickPayRecallStatus
}

export interface IQuickPayBalanceResult {
    totalBalance: string,
    label1?: string,
    balance1?: string,
    label2?: string,
    balance2?: string,
    label3?: string,
    balance3?: string,
    label4?: string,
    balance4?: string,
    label5?: string,
    balance5?: string,
    label6?: string,
    balance6?: string,
    label7?: string,
    balance7?: string,
    label8?: string,
    balance8?: string
}

export interface IQuickPayEmployerResult {
    employeeType?: string,
    dependentOf: string,
    employerName: string,
    clinicAccessStartDate?: NoTzDate,
    clinicAccessEndDate?: NoTzDate,
    registrationDate?: NoTzDate,
    wellnessDate?: NoTzDate,
    healthPlan?: string,
    department?: string,
    population?: string,
    locality?: string
}

export interface IQuickPayPopulationHealthItem {
    description: string,
    loadDate?: NoTzDate,
    contactDate?: NoTzDate,
    contactMethod?: string,
    contactNote?: string,
    userId?: string
}

export interface IQuickPayPlaymentPlanItem {
    paymentPlanId: number,
    totalAmount: number,
    remainingTotal: number,
    nextDueDate: string,
    status: string
}
export interface IQuickPayDemographicsSummaryResult {
    chart: IQuickPayChartResult,
    insuredList: IQuickPayInsuredItem[],
    responsiblePartyList: IQuickPayResponsiblePartyItem[],
    contactList: IQuickPayContactItem[],
    previousVisitList: IQuickPayAppointmentItem[],
    nextVisitList: IQuickPayAppointmentItem[],
    caseList: IQuickPayCaseItem[],
    recallNextList: IQuickPayRecallItem[],
    recallPreviousList: IQuickPayRecallItem[],
    balance: IQuickPayBalanceResult,
    employer?: IQuickPayEmployerResult,
    slidingFee?: string,
    populationHealthList: IQuickPayPopulationHealthItem[],
    paymentPlanList: IQuickPayPlaymentPlanItem[]
}

export interface IQuickPayIDResult {
    imageIdPhotograph?: number,
    imageIdPrimaryInsuranceCard1?: number,
    imageIdPrimaryInsuranceCard2?: number,
    imageIdSecondaryInsuranceCard1?: number,
    imageIdSecondaryInsuranceCard2?: number,
    imageIdPatientIdCard?: number,
    imageIdPharmacyBenefitCard1?: number,
    imageIdPharmacyBenefitCard2?: number,
    menuIdPhotograph: number,
    menuIdPrimaryInsuranceCard: number,
    menuIdSecondaryInsuranceCard: number,
    menuIdPatientIdCard: number,
    menuIdPharmacyBenefitCard: number,
    menuPathPhotograph: string,
    menuPathPrimaryInsuranceCard: string,
    menuPathSecondaryInsuranceCard: string,
    menuPathPatientIdCard: string,
    menuPathPharmacyBenefitCard: string,
    maxPrivilegePhotograph: PrivilegeType,
    maxPrivilegePrimaryInsuranceCard: PrivilegeType,
    maxPrivilegeSecondaryInsuranceCard: PrivilegeType,
    maxPrivilegePatientIdCard: PrivilegeType,
    maxPrivilegePharmacyBenefitCard: PrivilegeType,
    extensionPhotograph?: string,
    extensionPrimaryInsuranceCard1?: string,
    extensionPrimaryInsuranceCard2?: string,
    extensionSecondaryInsuranceCard1?: string,
    extensionSecondaryInsuranceCard2?: string,
    extensionPatientIdCard?: string,
    extensionPharmacyBenefitCard1?: string,
    extensionPharmacyBenefitCard2?: string
}

export interface IQuickPayIDResponse {
    ids: IQuickPayIDResult,
    insuredList: IQuickPayInsuredItem[]
}

export interface IQuickPayPatientResult {
    patientId: number,
    patientEid: number,
    patientName: string,
    providerEid?: number,
    scheduleDate: NoTzDate,
    securityUsersId: number
}

export interface IQuickPayReceiptItem {
    receiptId: number,
    paidByEid: string,
    paidByName: string,
    paidAmount: string,
    paymentMethodId?: string,
    paymentMethodDescription?: string,
    paymentMethodIdNumber?: string,
    paymentDate?: NoTzDate,
    comment?: string,
    reversalId?: number,
    userId: string,
    paymentTypeId?: string,
    paymentTypeDescription: string
}

export interface IQuickPayReceiptAppointment {
    appointmentId?: number,
    appointmentDisplay?: string,
    resourceName?: string,
    serviceLocationEid?: number,
    serviceLocationName?: string,
    primaryCarePhysician?: string,
    claimId?: number,
    receiptBatchId?: number,
    patientName: string
}

export interface IQuickPayReceiptCharge {
   claimId?: number,
   receiptTotal?: string,
   claimTotal?: string,
   chargeBalance?: string,
   chargePercent?: string,
   zeroReceiptsAllowed: boolean,
   paymentBatch: PaymentBatchPosting,
   estimatedBalance?: string,
   estimatedBalanceMessage?: string
}

export interface IQuickPayReceiptResponsibleParty {
    rpEntityId: number,
    rpId: number,
    rpName: string,
    rpEntityName: string
}

export interface IQuickPayReceiptPaymentType {
    paymentTypeId: number,
    paymentTypeDesc: string
}

export interface IQuickPayReceiptPaymentMethod {
    paymentMethodId: number,
    paymentMethodDesc: string,
    creditCard: boolean
}

export interface IQuickPayReceiptDefaultItem {
    controlName: string,
    defaultValue?: string, 
    requiredText?: string
}
export interface IQuickPayReceiptDefaultItem {
    defaultPaymentPlanMethod: number,
    defaultPaymentPlanType: number 
}
export interface IQuickPayReceiptResponse {
    appointment: IQuickPayReceiptAppointment,
    charge: IQuickPayReceiptCharge,
    receiptList: IQuickPayReceiptItem[],
    insuredList: IQuickPayInsuredItem[],
    responsiblePartyList: IQuickPayReceiptResponsibleParty[],
    paymentTypeList: IQuickPayReceiptPaymentType[],
    paymentMethodList: IQuickPayReceiptPaymentMethod[],
    defaultList: IQuickPayReceiptDefaultItem[],
    defaultPaymentPlanIds: IQuickPayReceiptDefaultItem
}

export interface IQuickPayReceiptRecord {
    receiptBatchId?: number,
    appointmentId: number,
    paidByEid?: number,
    paidAmount?: string,
    patientEid: number,
    idNumber?: string,
    comment?: string,
    paymentMethodId?: number,
    paymentTypeId?: number,
    includeClaim: boolean,
    includeProcedure: boolean,
    includeDiagnosis: boolean,
    includeComment: boolean,
    serviceLocationEid?: number,
    paymentBatchId?: number,
    paymentPlanId?: number
}

export interface IQuickPayTakePaymentInputs {
    useReceipt: boolean,
    requirePayment: boolean,
    childCallback: boolean,
    paidByType: number, 
    paidByID?: number, 
    paidByName?: string,
    appointmentID?: number, 
    paidByEID?: number, 
    serviceLocationEID?: number,
    paymentMethod?: number,
    paymentType?: number,
    receiptAmount: number,
    comment?: string,
    batch?: number,
    claimIndicator: string,
    commentIndicator: string,
    procedureIndicator: string,
    diagnosisIndicator: string,
    copayIndicator: boolean,
    paymentBatchID?: number,
    paymentBatchData?: string,
    paymentPlanID?: number,
    paymentPlanData?: string    
}

export interface IQuickPayReceiptCreateResponse {
    passed: boolean,
    receiptBatchId?: number,
    message?: string
}

export interface IQuickPayReceiptBatchIdCreateResponse {
    receiptBatchId?: number
}

export interface IQuickPayEmrFrameInputs {
    tabName?: string, 
    securityUsersId?: number, 
    patientId: number, 
    patientEid?: number, 
    providerEid?: number, 
    appointmentId?: number, 
    walkInPatient: string, 
    encounterDate?: string, 
    encounterTime?: string, 
    searchCriteria?: string, 
    patientPullType?: string,
    patientPullData?: string,
    claimId?: number
}

export interface IQuickPayTabNotificationResult {
    lettersExist: boolean,
    ordersExist: boolean,
    newRxExist: boolean,
    claimExist: boolean,
    receiptsExist: boolean,
    printExist: boolean,
    authExist: boolean,
    intakeExist: boolean,
    demoExist: boolean,
    demoMessage?: string
}

export interface IQuickPayRxHistoryItem {
    prescriptionId: number,
    method: number, 
    statusCode: number,
    statusDesc: string,
    action: string,
    startDate: string,
    drugName: string,
    refillDate: string,
    communciationStatus: string,
    pharmacyId?: number,
    pharmacyName: string,
    surescriptsPharmacy: boolean,
    methodDesc: string
}

export interface IQuickPayRxPharmacyItem {
    pharmacyId: number,
    pharmacyName: string,
    surescriptsPharmacy: boolean,
    address1: string,
    address2: string,
    city: string,
    state: string,
    zipCode: string,
    active: boolean,
    phoneWork: string,
    phoneFax: string
}

export interface IQuickPayRxResponse {
    historyList: IQuickPayRxHistoryItem[],
    pharmacyList: IQuickPayRxPharmacyItem[]
}

export enum QuickPayRecallStatus {
    Recall = 1,
    LetterSent = 2,
    Called = 3,
    Scheduled = 4,
    Cancelled = 5
}

export enum PaymentBatchPosting {
    Disabled = 0,
    On = 1,
    Required = 2
}

export enum EmrAction {
    History = "Toolbar_History",
    New = "Toolbar_New",
    Print = "Toolbar_Print",
    Save = "Toolbar_Save",
    Audit = "Toolbar_Audit",
    EncounterDate = "Toolbar_EncounterDate",
    Copy = "Toolbar_Copy",
    OpenClaim = "Open_Claim"
}

export enum EmrActionData {
    DisplayHistory = "History",
    DisplaySummary = "Summary",
    NoData = ""
}